<template>
  <div class="zj-demo-chart">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;">基于消息通知的 TCP/UDP 连接示例</h1>
        <el-form style="margin: 2rem 6rem 1rem 6rem;" label-width="13rem">
          <el-form-item label="服务地址：">
            <el-input v-model="address" placeholder="服务地址"></el-input>
          </el-form-item>
          <el-form-item label="连接协议：">
            <el-radio v-model="protocol" label="tcp">TCP</el-radio>
            <el-radio v-model="protocol" label="udp">UDP</el-radio>
          </el-form-item>
          <el-form-item label="请求头：">
            <el-input v-model="request" placeholder="请求头" type="textarea" rows="5" style="width: 50rem;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleConnect" style="margin: 0rem 0rem 0rem 3rem;">连接</el-button>
            <el-button type="primary" @click="handleDisConnect" style="margin: 0rem 0rem 0rem 3rem;">断开</el-button>
            <el-button type="primary" @click="handleSend" style="margin: 0rem 0rem 0rem 6rem;">发送</el-button>
            <el-button type="primary" @click="handleClear" style="margin: 0rem 0rem 0rem 3rem;">清空</el-button>
          </el-form-item>
        </el-form>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">
          <pre>{{response}}</pre>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from '../../../../app'
export default {
    name: 'ZjDemoChart',
    controller: 'UI',
    action: 'socket',
    data() {
        return {
          ws: null,
          protocol: 'tcp',
          address: 'www.baidu.com:80',
          request: 'GET / HTTP/1.1\r\nHost: www.baidu.com\r\n\r\n',
          response: ''
        };
    },
    created() {
    },
    destroyed() {
      if (this.sock) {
        this.sock.close();
        this.sock = null;
      }
    },
    methods: {
      append(s) {
        this.response += s;
        this.$nextTick(()=> {
          const container = this.$refs.container;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });
      },
      handleConnect() {
        if (this.sock && this.sock.connected) {
          this.append('请先断开连接\r\n');
        }
        else {
          const that = this;
          const arr = this.address.split(':');
          const cls = this.protocol === 'tcp' ? ZJApp.ZJNotify.TcpSocket : ZJApp.ZJNotify.UdpSocket;
          const sock = new cls(arr[0], parseInt(arr[1]) || 80);
          sock.on('open', function (e) {
              console.log('open', e);
              that.append('连接已建立\r\n');
          });

          sock.on('close', function (e) {
              console.log('close', e);
              that.append('连接已关闭\r\n');
          });

          sock.on('error', function (e) {
              console.error('error', e);
              that.append('出错：' + e + '\r\n');
          });

          sock.on('recv', function (e) {
              let s = e.data.toUTF8String();
              that.append(s);
          });
          this.sock = sock;
          this.append('连接中...\r\n');
          sock.open();
        }
      },
      handleDisConnect() {
        if (this.sock && this.sock.connected) {
          this.append('关闭中...\r\n');
          this.sock.close();
          this.sock = null;
        }
        else {
          this.append('还未连接\r\n');
        }
      },
      handleSend() {
        if (this.sock) {
          if (this.sock.connected) {
            this.sock.send(this.request);
          }
          else {
            this.append('正在连接目标服务器，请连接成功后再发送数据\r\n');
          }
        }
        else {
          this.append('还未连接\r\n');
        }
      },
      handleClear() {
        this.response = '';
      }
    }
}
</script>

<style lang="scss" scoped>
ul.zj-demo-chart-msg-list,
ul.zj-demo-chart-button-bar {
    list-style: none;
    padding: 2rem 2rem;
    margin: 0;

    &>li {
      list-style: none;
      padding: 2rem 2rem;
      margin: 0;
    }
}
</style>